class StorageService {
  constructor() {
    this.dbConfig = {
      databaseName: 'version-1-msoutlook-db',
      version: 1,
      stores: [
        {
          name: 'users',
          id: { keyPath: 'id', autoIncrement: false },
          indices: [
            { name: 'token', keypath: 'token', options: { unique: false } },
            { name: 'userid', keypath: 'userid', options: { unique: false } },
            { name: 'crm_url', keypath: 'crm_url', options: { unique: false } },
            { name: 'username', keypath: 'username', options: { unique: false } },
          ],
        },
      ],
    };
    this.dbName = 'version-1-msoutlook-db';
    this.version = 1;
  }

  async openDB() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, this.version);
      
      request.onerror = () => {
        reject(request.error);
      };
      
      request.onsuccess = () => {
        resolve(request.result);
      };
      
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('users')) {
          const store = db.createObjectStore('users', { keyPath: 'id' });
          store.createIndex('token', 'token', { unique: false });
          store.createIndex('userid', 'userid', { unique: false });
          store.createIndex('crm_url', 'crm_url', { unique: false });
          store.createIndex('username', 'username', { unique: false });
        }
      };
    });
  }

  async getUser() {
    try {
      const db = await this.openDB();
      
      return new Promise((resolve, reject) => {
        const transaction = db.transaction(['users'], 'readonly');
        const store = transaction.objectStore('users');
        
        // First try to get user with ID 1
        const request = store.get(1);
        
        request.onerror = () => {
          // If that fails, try to get any user from the store
          this.getAnyUser(store).then(resolve).catch(reject);
        };
        
        request.onsuccess = () => {
          const user = request.result;
          if (user) {
            resolve(user);
          } else {
            // If no user with ID 1, try to get any user
            this.getAnyUser(store).then(resolve).catch(reject);
          }
        };
        
        transaction.onerror = () => {
          reject(transaction.error);
        };
      });
    } catch (error) {
      return null;
    }
  }

  async getAnyUser(store) {
    return new Promise((resolve, reject) => {
      const request = store.getAll();
      
      request.onerror = () => {
        reject(request.error);
      };
      
      request.onsuccess = () => {
        const users = request.result;
        
        if (users && users.length > 0) {
          const user = users[0]; // Get the first user
          resolve(user);
        } else {
          resolve(null);
        }
      };
    });
  }

  async saveUser(userData) {
    try {
      const db = await this.openDB();
      
      return new Promise((resolve, reject) => {
        const transaction = db.transaction(['users'], 'readwrite');
        const store = transaction.objectStore('users');
        
        // Clear any existing users first to ensure clean state
        const clearRequest = store.clear();
        
        clearRequest.onerror = () => {
          reject(clearRequest.error);
        };
        
        clearRequest.onsuccess = () => {
          const userDataWithId = {
            id: 1,
            ...userData,
          };

          const saveRequest = store.put(userDataWithId);
          
          saveRequest.onerror = () => {
            reject(saveRequest.error);
          };
          
          saveRequest.onsuccess = () => {
            resolve(saveRequest.result);
          };
        };
        
        // Handle transaction completion
        transaction.oncomplete = () => {
        };
        
        transaction.onerror = () => {
          reject(transaction.error);
        };
      });
    } catch (error) {
      throw error;
    }
  }

  async deleteUser() {
    try {
      const db = await this.openDB();
      
      return new Promise((resolve, reject) => {
        const transaction = db.transaction(['users'], 'readwrite');
        const store = transaction.objectStore('users');
        
        // Clear all users to ensure complete cleanup
        const request = store.clear();
        
        request.onerror = () => {
          reject(request.error);
        };
        
        request.onsuccess = () => {
          resolve(request.result);
        };
        
        transaction.onerror = () => {
          reject(transaction.error);
        };
      });
    } catch (error) {
      throw error;
    }
  }

  getDbConfig() {
    return this.dbConfig;
  }
}

export default new StorageService();